/* ============================================================
   No Dirt Golf — DYO Product Customizer
   Golf Towel edition — Canvas 600×400
   ============================================================ */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     Wait for DOM
  ---------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var cfg = window.DYOConfig;
    if (!cfg) return; // not on a DYO page

    /* --------------------------------------------------------
       Constants
    -------------------------------------------------------- */
    var CW = 600;
    var CH = 400;
    var MIN_LOGO_PX = 24;
    var HANDLE_SIZE = 9; // half-size of corner handle square

    /* --------------------------------------------------------
       Print zone (percentage-based, resolved to pixels)
    -------------------------------------------------------- */
    var PZ = {
      x: Math.round(cfg.printZone.xPct * CW),
      y: Math.round(cfg.printZone.yPct * CH),
      w: Math.round(cfg.printZone.wPct * CW),
      h: Math.round(cfg.printZone.hPct * CH),
    };

    /* --------------------------------------------------------
       State
    -------------------------------------------------------- */
    var logo = {
      img: null,
      x: PZ.x + PZ.w / 2 - 60,
      y: PZ.y + PZ.h / 2 - 60,
      w: 120,
      h: 120,
      loaded: false,
    };
    var logoConfirmed = false;
    var propLogoUrl = '';
    var propPreviewUrl = '';
    var currentVariantPrice = 0; // in cents
    var qty = 1;
    var uploadState = 'idle'; // idle | uploading | done | error
    var productImg = null;
    var productImgLoaded = false;

    // Text bounding box state
    var textObj = {
      fontSize: 32,
      x: 0,
      y: 0,
      w: 0,
      h: 0,
      placed: false,
      confirmed: false,
      vertical: false,
    };

    var textDrag = {
      active: false,
      mode: 'move',
      startX: 0,
      startY: 0,
      startObjX: 0,
      startObjY: 0,
      startFontSize: 0,
      startW: 0,
      startH: 0,
    };

    // Drag/resize state
    var SIZE_MAP = [0, 18, 24, 32, 40, 48]; // index 1-5
    var SIZE_LABELS = ['', 'small', 'small-medium', 'medium', 'medium-large', 'large'];
    var customText = {
      value: '',
      font: 'Georgia, serif',
      fontLabel: 'Classic',
      color: '#111111',
      colorLabel: 'Black',
      sizeStep: 3,
    };
    var customTextFeePrice = 0; // legacy — no longer used for price calc
    var resolvedMethods = []; // { key, label, variantId, price }
    var selectedMethod = null;

    var drag = {
      active: false,
      mode: 'move', // 'move' | 'nw' | 'ne' | 'sw' | 'se'
      startX: 0,
      startY: 0,
      startLogoX: 0,
      startLogoY: 0,
      startLogoW: 0,
      startLogoH: 0,
    };

    // Print zone editor mode — activated by ?edit_zone=1 in the URL (admin only)
    var PZ_EDIT_MODE = window.location.search.indexOf('edit_zone=1') !== -1;

    var pzDrag = {
      active: false,
      mode: 'move',
      startX: 0,
      startY: 0,
      startPZX: 0,
      startPZY: 0,
      startPZW: 0,
      startPZH: 0,
    };

    /* --------------------------------------------------------
       DOM refs
    -------------------------------------------------------- */
    var canvas    = document.getElementById('dyo-canvas');
    var ctx       = canvas ? canvas.getContext('2d') : null;

    var triggerBtn     = document.getElementById('dyo-trigger-btn');
    var dyoPanel       = document.getElementById('dyo-panel');
    var fileInput      = document.getElementById('dyo-file-input');
    var uploadBtn      = document.getElementById('dyo-upload-btn');
    var uploadIcon     = document.getElementById('dyo-upload-icon');
    var uploadLabel    = document.getElementById('dyo-upload-label');
    var confirmArea    = document.getElementById('dyo-confirm-area');
    var confirmBtn     = document.getElementById('dyo-confirm-btn');
    var repositionBtn  = document.getElementById('dyo-reposition-btn');
    var priceAmount    = document.getElementById('dyo-price-amount');
    var submitBtn      = document.getElementById('dyo-submit-btn');
    var submitNote     = document.getElementById('dyo-submit-note');
    var errorMsg       = document.getElementById('dyo-error-msg');
    var dyoForm        = document.getElementById('dyo-product-form');
    var variantIdInput = document.getElementById('dyo-variant-id');
    var qtyInput       = document.getElementById('dyo-qty-input');
    var qtyMinus       = document.getElementById('dyo-qty-minus');
    var qtyPlus        = document.getElementById('dyo-qty-plus');
    var propLogoUrlInput      = document.getElementById('prop-logo-url');
    var propPreviewUrlInput   = document.getElementById('prop-preview-url');
    var propLogoPositionInput = document.getElementById('prop-logo-position');
    var propCustomText        = document.getElementById('prop-custom-text');
    var propCustomTextFont    = document.getElementById('prop-custom-text-font');
    var propCustomTextColor   = document.getElementById('prop-custom-text-color');
    var propCustomTextSize    = document.getElementById('prop-custom-text-size');
    var textInput             = document.getElementById('dyo-text-input');
    var textCharCount         = document.getElementById('dyo-text-char-count');
    var fontPicker            = document.getElementById('dyo-font-picker');
    var colorSwatches         = document.getElementById('dyo-color-swatches');
    var sizeSlider            = document.getElementById('dyo-size-slider');
    var textConfirmArea       = document.getElementById('dyo-text-confirm-area');
    var textConfirmBtn        = document.getElementById('dyo-text-confirm-btn');
    var textRepositionBtn     = document.getElementById('dyo-text-reposition-btn');
    var methodCardsEl         = document.getElementById('dyo-method-cards');
    var propDecorationMethod  = document.getElementById('prop-decoration-method');

    if (!canvas || !ctx) return;

    // Seed text color from whichever swatch is marked active in the HTML
    if (colorSwatches) {
      var initSwatch = colorSwatches.querySelector('.dyo-color-swatch.is-active');
      if (initSwatch) {
        customText.color = initSwatch.getAttribute('data-color') || customText.color;
        customText.colorLabel = initSwatch.getAttribute('data-label') || customText.colorLabel;
      }
    }

    /* --------------------------------------------------------
       Variant setup
    -------------------------------------------------------- */
    var variants = cfg.variants || [];
    var currentVariant = variants[0] || null;

    // Read initial variant from hidden input
    if (variantIdInput && variantIdInput.value) {
      var initialId = parseInt(variantIdInput.value, 10);
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === initialId) {
          currentVariant = variants[i];
          break;
        }
      }
    }
    currentVariantPrice = currentVariant ? currentVariant.price : 0;

    /* --------------------------------------------------------
       Fetch decoration method prices
    -------------------------------------------------------- */
    var methods = cfg.decorationMethods || [];
    var methodFetchCount = methods.length;
    var methodFetchDone = 0;

    function onMethodFetchComplete() {
      methodFetchDone++;
      if (methodFetchDone >= methodFetchCount) {
        updatePriceDisplay();
      }
    }

    methods.forEach(function (m) {
      if (!m.variantId) {
        // No variant ID configured — show card but skip price fetch
        resolvedMethods.push({ key: m.key, label: m.label, variantId: '', price: 0 });
        onMethodFetchComplete();
        return;
      }
      fetch('/variants/' + m.variantId + '.js')
        .then(function (r) { return r.json(); })
        .then(function (v) {
          var resolved = { key: m.key, label: m.label, variantId: m.variantId, price: v.price || 0 };
          resolvedMethods.push(resolved);
          var priceEl = document.getElementById('dyo-method-price-' + m.key);
          if (priceEl) {
            priceEl.textContent = formatMoney(v.price || 0, cfg.money_format) + ' / element';
          }
          onMethodFetchComplete();
        })
        .catch(function () {
          resolvedMethods.push({ key: m.key, label: m.label, variantId: m.variantId, price: 0 });
          // Leave the price element as-is (shows the theme-editor display label)
          onMethodFetchComplete();
        });
    });

    /* --------------------------------------------------------
       Decoration method card selection
    -------------------------------------------------------- */
    if (methodCardsEl) {
      methodCardsEl.addEventListener('click', function (e) {
        var card = e.target.closest('.dyo-method-card');
        if (!card) return;
        var key = card.getAttribute('data-key');

        var found = null;
        for (var i = 0; i < resolvedMethods.length; i++) {
          if (resolvedMethods[i].key === key) { found = resolvedMethods[i]; break; }
        }
        if (!found) {
          var nameEl = card.querySelector('.dyo-method-card__name');
          found = { key: key, label: nameEl ? nameEl.textContent : key, variantId: card.getAttribute('data-variant-id'), price: 0 };
        }

        selectedMethod = found;
        if (propDecorationMethod) propDecorationMethod.value = key;

        var cards = methodCardsEl.querySelectorAll('.dyo-method-card');
        for (var j = 0; j < cards.length; j++) {
          cards[j].classList.remove('is-active');
          cards[j].setAttribute('aria-pressed', 'false');
        }
        card.classList.add('is-active');
        card.setAttribute('aria-pressed', 'true');

        updatePriceDisplay();
        updateSubmitState();
      });
    }

    /* --------------------------------------------------------
       Reveal button toggle
    -------------------------------------------------------- */
    if (triggerBtn && dyoPanel) {
      triggerBtn.addEventListener('click', function () {
        var isOpen = dyoPanel.classList.toggle('is-open');
        triggerBtn.classList.toggle('is-active', isOpen);
        triggerBtn.setAttribute('aria-expanded', String(isOpen));
        dyoPanel.setAttribute('aria-hidden', String(!isOpen));
        if (isOpen) {
          setTimeout(function () {
            dyoPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      });
    }

    /* --------------------------------------------------------
       Product image load
    -------------------------------------------------------- */
    if (cfg.productImage) {
      var pImg = new Image();
      pImg.crossOrigin = 'anonymous';
      pImg.onload = function () {
        productImg = pImg;
        productImgLoaded = true;

        // Resize canvas coordinate space to match image aspect ratio
        CH = Math.round(CW * pImg.naturalHeight / pImg.naturalWidth);
        canvas.height = CH;

        // Recalculate print zone with new canvas height
        PZ.x = Math.round(cfg.printZone.xPct * CW);
        PZ.y = Math.round(cfg.printZone.yPct * CH);
        PZ.w = Math.round(cfg.printZone.wPct * CW);
        PZ.h = Math.round(cfg.printZone.hPct * CH);

        // Auto-default text to vertical when print zone is portrait-oriented
        if (PZ.h > PZ.w && !textObj.placed) {
          textObj.vertical = true;
          syncRotateBtn();
        }

        drawCanvas();
      };
      pImg.onerror = function () {
        productImgLoaded = false;
        drawCanvas();
      };
      pImg.src = cfg.productImage;
    }

    /* --------------------------------------------------------
       drawCanvas
    -------------------------------------------------------- */
    function drawCanvas() {
      ctx.clearRect(0, 0, CW, CH);

      // --- Background ---
      if (productImgLoaded && productImg) {
        drawCoverImage(productImg);
      } else {
        // Light green towel background
        ctx.fillStyle = '#eef6e6';
        ctx.fillRect(0, 0, CW, CH);

        // Subtle microfiber texture lines
        ctx.save();
        ctx.strokeStyle = 'rgba(58,106,32,0.06)';
        ctx.lineWidth = 1;
        var lineCount = 20;
        var lineSpacing = CH / lineCount;
        for (var li = 0; li <= lineCount; li++) {
          var ly = Math.round(li * lineSpacing);
          ctx.beginPath();
          ctx.moveTo(0, ly);
          ctx.lineTo(CW, ly);
          ctx.stroke();
        }
        ctx.restore();

        // Subtle towel border/shadow
        ctx.save();
        ctx.strokeStyle = 'rgba(26,46,26,0.1)';
        ctx.lineWidth = 3;
        ctx.strokeRect(1.5, 1.5, CW - 3, CH - 3);
        ctx.restore();
      }

      // --- Dark scrim outside print zone (even-odd rule) ---
      ctx.save();
      ctx.fillStyle = 'rgba(0,0,0,0.3)';
      ctx.beginPath();
      // outer rect (canvas)
      ctx.rect(0, 0, CW, CH);
      // inner rect (print zone) — wound in opposite direction for evenodd
      ctx.rect(PZ.x, PZ.y, PZ.w, PZ.h);
      ctx.fill('evenodd');
      ctx.restore();

      // --- Print zone border ---
      ctx.save();
      if (PZ_EDIT_MODE) {
        ctx.strokeStyle = '#e87722';
        ctx.lineWidth = 2.5;
      } else {
        ctx.strokeStyle = 'rgba(58,106,32,0.85)';
        ctx.lineWidth = 1.5;
        ctx.setLineDash([6, 4]);
      }
      ctx.strokeRect(PZ.x, PZ.y, PZ.w, PZ.h);
      ctx.setLineDash([]);
      ctx.restore();

      // --- PZ editor corner handles (admin mode only) ---
      if (PZ_EDIT_MODE) {
        ctx.save();
        ctx.fillStyle = '#e87722';
        var pzCorns = getPZCorners();
        for (var pk in pzCorns) {
          if (!pzCorns.hasOwnProperty(pk)) continue;
          ctx.fillRect(pzCorns[pk].x - HANDLE_SIZE / 2, pzCorns[pk].y - HANDLE_SIZE / 2, HANDLE_SIZE, HANDLE_SIZE);
        }
        ctx.restore();
      }

      // --- "Your logo here" placeholder ---
      if (!logo.loaded && !customText.value.trim()) {
        ctx.save();
        ctx.fillStyle = 'rgba(58,106,32,0.55)';
        ctx.font = '500 13px Figtree, sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.translate(PZ.x + PZ.w / 2, PZ.y + PZ.h / 2);
        if (PZ.h > PZ.w) ctx.rotate(-Math.PI / 2);
        ctx.fillText('Your logo here', 0, 0);
        ctx.restore();
      }

      // --- Logo image ---
      if (logo.loaded && logo.img) {
        ctx.save();
        // Clip to print zone
        ctx.beginPath();
        ctx.rect(PZ.x, PZ.y, PZ.w, PZ.h);
        ctx.clip();
        ctx.drawImage(logo.img, logo.x, logo.y, logo.w, logo.h);
        ctx.restore();

        // Resize handles (shown when not confirmed)
        if (!logoConfirmed) {
          drawHandles();
        }
      }

      // --- Custom text layer ---
      drawTextLayer();

    }

    /* --------------------------------------------------------
       Draw cover-fit product image
    -------------------------------------------------------- */
    function drawCoverImage(img) {
      // Canvas has been resized to match image aspect ratio, so draw fills exactly
      ctx.drawImage(img, 0, 0, CW, CH);
    }

    /* --------------------------------------------------------
       Draw corner resize handles
    -------------------------------------------------------- */
    function drawHandles() {
      var corners = getCorners();
      ctx.save();
      ctx.fillStyle = '#3a6a20';
      for (var k in corners) {
        if (!corners.hasOwnProperty(k)) continue;
        var c = corners[k];
        ctx.fillRect(c.x - HANDLE_SIZE / 2, c.y - HANDLE_SIZE / 2, HANDLE_SIZE, HANDLE_SIZE);
      }
      ctx.restore();
    }

    /* --------------------------------------------------------
       Text bounding box helpers
    -------------------------------------------------------- */
    function updateTextBounds() {
      var t = customText.value.trim();
      if (!t) { textObj.placed = false; return; }

      textObj.fontSize = SIZE_MAP[customText.sizeStep] || 32;
      ctx.font = textObj.fontSize + 'px ' + customText.font;
      var rawW = ctx.measureText(t).width + 8;
      var rawH = textObj.fontSize * 1.2;
      var bW = textObj.vertical ? rawH : rawW;
      var bH = textObj.vertical ? rawW : rawH;

      if (!textObj.placed) {
        textObj.w = bW;
        textObj.h = bH;
        var zoneY = logo.loaded ? PZ.y + Math.round(PZ.h * 0.6) : PZ.y;
        var zoneH = logo.loaded ? Math.round(PZ.h * 0.4) : PZ.h;
        textObj.x = PZ.x + (PZ.w - textObj.w) / 2;
        textObj.y = zoneY + (zoneH - textObj.h) / 2;
        textObj.placed = true;
      } else {
        var prevCX = textObj.x + textObj.w / 2;
        var prevCY = textObj.y + textObj.h / 2;
        textObj.w = bW;
        textObj.h = bH;
        textObj.x = prevCX - textObj.w / 2;
        textObj.y = prevCY - textObj.h / 2;
        constrainText();
      }
    }

    function drawTextHandles() {
      var corners = getTextCorners();
      ctx.save();
      ctx.fillStyle = '#3a6a20';
      for (var k in corners) {
        if (!corners.hasOwnProperty(k)) continue;
        var c = corners[k];
        ctx.fillRect(c.x - HANDLE_SIZE / 2, c.y - HANDLE_SIZE / 2, HANDLE_SIZE, HANDLE_SIZE);
      }
      ctx.restore();
    }

    function getTextCorners() {
      return {
        nw: { x: textObj.x,               y: textObj.y },
        ne: { x: textObj.x + textObj.w,   y: textObj.y },
        sw: { x: textObj.x,               y: textObj.y + textObj.h },
        se: { x: textObj.x + textObj.w,   y: textObj.y + textObj.h },
      };
    }

    function hitTextHandle(mx, my) {
      if (!textObj.placed || textObj.confirmed) return null;
      var corners = getTextCorners();
      var hs = HANDLE_SIZE;
      for (var k in corners) {
        if (!corners.hasOwnProperty(k)) continue;
        var c = corners[k];
        if (mx >= c.x - hs && mx <= c.x + hs && my >= c.y - hs && my <= c.y + hs) {
          return k;
        }
      }
      return null;
    }

    function hitText(mx, my) {
      if (!textObj.placed || textObj.confirmed) return false;
      return mx >= textObj.x && mx <= textObj.x + textObj.w &&
             my >= textObj.y && my <= textObj.y + textObj.h;
    }

    function constrainText() {
      textObj.x = Math.max(PZ.x, Math.min(PZ.x + PZ.w - textObj.w, textObj.x));
      textObj.y = Math.max(PZ.y, Math.min(PZ.y + PZ.h - textObj.h, textObj.y));
    }

    /* --------------------------------------------------------
       Draw custom text in print zone
    -------------------------------------------------------- */
    function drawTextLayer() {
      var t = customText.value.trim();
      if (!t || !textObj.placed) return;

      ctx.save();
      ctx.beginPath();
      ctx.rect(PZ.x, PZ.y, PZ.w, PZ.h);
      ctx.clip();

      var tcx = textObj.x + textObj.w / 2;
      var tcy = textObj.y + textObj.h / 2;

      ctx.font = textObj.fontSize + 'px ' + customText.font;
      ctx.fillStyle = customText.color;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      if (textObj.vertical) {
        ctx.save();
        ctx.translate(tcx, tcy);
        ctx.rotate(-Math.PI / 2);
        ctx.fillText(t, 0, 0);
        ctx.restore();
      } else {
        ctx.fillText(t, tcx, tcy);
      }

      if (!textObj.confirmed) {
        drawTextHandles();
      }

      ctx.restore();
    }

    /* --------------------------------------------------------
       Utility: rounded rect path
    -------------------------------------------------------- */
    function roundRect(c, x, y, w, h, r) {
      c.beginPath();
      c.moveTo(x + r, y);
      c.lineTo(x + w - r, y);
      c.quadraticCurveTo(x + w, y, x + w, y + r);
      c.lineTo(x + w, y + h - r);
      c.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
      c.lineTo(x + r, y + h);
      c.quadraticCurveTo(x, y + h, x, y + h - r);
      c.lineTo(x, y + r);
      c.quadraticCurveTo(x, y, x + r, y);
      c.closePath();
    }

    /* --------------------------------------------------------
       Print zone corner helpers (used in edit mode)
    -------------------------------------------------------- */
    function getPZCorners() {
      return {
        nw: { x: PZ.x,        y: PZ.y },
        ne: { x: PZ.x + PZ.w, y: PZ.y },
        sw: { x: PZ.x,        y: PZ.y + PZ.h },
        se: { x: PZ.x + PZ.w, y: PZ.y + PZ.h },
      };
    }

    function hitPZHandle(mx, my) {
      var corners = getPZCorners();
      var hs = HANDLE_SIZE + 3; // slightly larger hit area for PZ handles
      for (var k in corners) {
        if (!corners.hasOwnProperty(k)) continue;
        var c = corners[k];
        if (mx >= c.x - hs && mx <= c.x + hs && my >= c.y - hs && my <= c.y + hs) return k;
      }
      return null;
    }

    function hitPZBody(mx, my) {
      return mx >= PZ.x && mx <= PZ.x + PZ.w && my >= PZ.y && my <= PZ.y + PZ.h;
    }

    /* --------------------------------------------------------
       Corner coordinates
    -------------------------------------------------------- */
    function getCorners() {
      return {
        nw: { x: logo.x,            y: logo.y },
        ne: { x: logo.x + logo.w,   y: logo.y },
        sw: { x: logo.x,            y: logo.y + logo.h },
        se: { x: logo.x + logo.w,   y: logo.y + logo.h },
      };
    }

    /* --------------------------------------------------------
       Hit test helpers
    -------------------------------------------------------- */
    function hitHandle(mx, my) {
      if (!logo.loaded || logoConfirmed) return null;
      var corners = getCorners();
      var hs = HANDLE_SIZE;
      for (var k in corners) {
        if (!corners.hasOwnProperty(k)) continue;
        var c = corners[k];
        if (mx >= c.x - hs && mx <= c.x + hs && my >= c.y - hs && my <= c.y + hs) {
          return k;
        }
      }
      return null;
    }

    function hitLogo(mx, my) {
      if (!logo.loaded || logoConfirmed) return false;
      return mx >= logo.x && mx <= logo.x + logo.w &&
             my >= logo.y && my <= logo.y + logo.h;
    }

    /* --------------------------------------------------------
       Canvas coordinate mapping
    -------------------------------------------------------- */
    function canvasCoords(e) {
      var rect = canvas.getBoundingClientRect();
      var scaleX = CW / rect.width;
      var scaleY = CH / rect.height;
      var src = e.touches ? e.touches[0] : e;
      return {
        x: (src.clientX - rect.left) * scaleX,
        y: (src.clientY - rect.top)  * scaleY,
      };
    }

    /* --------------------------------------------------------
       Constrain logo inside print zone
    -------------------------------------------------------- */
    function constrainLogo() {
      logo.x = Math.max(PZ.x, Math.min(PZ.x + PZ.w - logo.w, logo.x));
      logo.y = Math.max(PZ.y, Math.min(PZ.y + PZ.h - logo.h, logo.y));
    }

    /* --------------------------------------------------------
       Cursor update
    -------------------------------------------------------- */
    function updateCursor(mx, my) {
      var h  = hitHandle(mx, my);
      var th = hitTextHandle(mx, my);
      var ph = PZ_EDIT_MODE ? hitPZHandle(mx, my) : null;
      if (h === 'nw' || h === 'se' || th === 'nw' || th === 'se' || ph === 'nw' || ph === 'se') {
        canvas.className = 'dyo-cursor-nwse';
      } else if (h === 'ne' || h === 'sw' || th === 'ne' || th === 'sw' || ph === 'ne' || ph === 'sw') {
        canvas.className = 'dyo-cursor-nesw';
      } else if (hitLogo(mx, my) || hitText(mx, my) || (PZ_EDIT_MODE && hitPZBody(mx, my))) {
        canvas.className = 'dyo-cursor-grab';
      } else {
        canvas.className = '';
      }
    }

    /* --------------------------------------------------------
       Mouse / touch events on canvas
    -------------------------------------------------------- */
    function onPointerDown(e) {
      var pt = canvasCoords(e);

      // PZ edit mode — handle print zone drag/resize before anything else
      if (PZ_EDIT_MODE) {
        var pzH = hitPZHandle(pt.x, pt.y);
        if (pzH) {
          pzDrag.active = true;
          pzDrag.mode = pzH;
          pzDrag.startX = pt.x; pzDrag.startY = pt.y;
          pzDrag.startPZX = PZ.x; pzDrag.startPZY = PZ.y;
          pzDrag.startPZW = PZ.w; pzDrag.startPZH = PZ.h;
          canvas.className = 'dyo-cursor-grabbing';
          e.preventDefault();
          return;
        } else if (hitPZBody(pt.x, pt.y)) {
          pzDrag.active = true;
          pzDrag.mode = 'move';
          pzDrag.startX = pt.x; pzDrag.startY = pt.y;
          pzDrag.startPZX = PZ.x; pzDrag.startPZY = PZ.y;
          pzDrag.startPZW = PZ.w; pzDrag.startPZH = PZ.h;
          canvas.className = 'dyo-cursor-grabbing';
          e.preventDefault();
          return;
        }
      }

      // Logo drag
      if (logo.loaded && !logoConfirmed) {
        var handle = hitHandle(pt.x, pt.y);
        if (handle) {
          drag.active = true;
          drag.mode = handle;
          drag.startX = pt.x;
          drag.startY = pt.y;
          drag.startLogoX = logo.x;
          drag.startLogoY = logo.y;
          drag.startLogoW = logo.w;
          drag.startLogoH = logo.h;
          canvas.className = 'dyo-cursor-grabbing';
          e.preventDefault();
          return;
        } else if (hitLogo(pt.x, pt.y)) {
          drag.active = true;
          drag.mode = 'move';
          drag.startX = pt.x;
          drag.startY = pt.y;
          drag.startLogoX = logo.x;
          drag.startLogoY = logo.y;
          canvas.className = 'dyo-cursor-grabbing';
          e.preventDefault();
          return;
        }
      }

      // Text drag
      if (textObj.placed && !textObj.confirmed) {
        var textHandle = hitTextHandle(pt.x, pt.y);
        if (textHandle) {
          textDrag.active = true;
          textDrag.mode = textHandle;
          textDrag.startX = pt.x;
          textDrag.startY = pt.y;
          textDrag.startObjX = textObj.x;
          textDrag.startObjY = textObj.y;
          textDrag.startFontSize = textObj.fontSize;
          textDrag.startW = textObj.w;
          textDrag.startH = textObj.h;
          canvas.className = 'dyo-cursor-grabbing';
          e.preventDefault();
        } else if (hitText(pt.x, pt.y)) {
          textDrag.active = true;
          textDrag.mode = 'move';
          textDrag.startX = pt.x;
          textDrag.startY = pt.y;
          textDrag.startObjX = textObj.x;
          textDrag.startObjY = textObj.y;
          canvas.className = 'dyo-cursor-grabbing';
          e.preventDefault();
        }
      }
    }

    function onPointerMove(e) {
      if (!drag.active && !textDrag.active && !pzDrag.active) {
        var pt2 = canvasCoords(e);
        updateCursor(pt2.x, pt2.y);
        return;
      }
      e.preventDefault();
      var pt = canvasCoords(e);

      if (drag.active) {
        var dx = pt.x - drag.startX;
        var dy = pt.y - drag.startY;

        if (drag.mode === 'move') {
          logo.x = drag.startLogoX + dx;
          logo.y = drag.startLogoY + dy;
          constrainLogo();
        } else {
          var aspect = drag.startLogoW / drag.startLogoH;
          var newW, newH;

          if (drag.mode === 'se') {
            newW = Math.max(MIN_LOGO_PX, drag.startLogoW + dx);
            newH = newW / aspect;
            logo.w = newW; logo.h = newH;
          } else if (drag.mode === 'sw') {
            newW = Math.max(MIN_LOGO_PX, drag.startLogoW - dx);
            newH = newW / aspect;
            logo.x = drag.startLogoX + drag.startLogoW - newW;
            logo.w = newW; logo.h = newH;
          } else if (drag.mode === 'ne') {
            newW = Math.max(MIN_LOGO_PX, drag.startLogoW + dx);
            newH = newW / aspect;
            logo.y = drag.startLogoY + drag.startLogoH - newH;
            logo.w = newW; logo.h = newH;
          } else if (drag.mode === 'nw') {
            newW = Math.max(MIN_LOGO_PX, drag.startLogoW - dx);
            newH = newW / aspect;
            logo.x = drag.startLogoX + drag.startLogoW - newW;
            logo.y = drag.startLogoY + drag.startLogoH - newH;
            logo.w = newW; logo.h = newH;
          }

          if (logo.w > PZ.w) { logo.w = PZ.w; logo.h = PZ.w / aspect; }
          if (logo.h > PZ.h) { logo.h = PZ.h; logo.w = PZ.h * aspect; }
          constrainLogo();
        }
        drawCanvas();

      } else if (textDrag.active) {
        var tdx = pt.x - textDrag.startX;
        var tdy = pt.y - textDrag.startY;

        if (textDrag.mode === 'move') {
          textObj.x = textDrag.startObjX + tdx;
          textObj.y = textDrag.startObjY + tdy;
          constrainText();
        } else {
          // Resize — scale axis depends on orientation
          var scaleVal;
          var t2 = customText.value.trim();

          if (textObj.vertical) {
            // Height is the text-length dimension; scale from dy
            if (textDrag.mode === 'se' || textDrag.mode === 'sw') {
              scaleVal = Math.max(0.2, (textDrag.startH + tdy) / textDrag.startH);
            } else {
              scaleVal = Math.max(0.2, (textDrag.startH - tdy) / textDrag.startH);
            }
          } else {
            // Width is the text-length dimension; scale from dx
            if (textDrag.mode === 'se' || textDrag.mode === 'ne') {
              scaleVal = Math.max(0.2, (textDrag.startW + tdx) / textDrag.startW);
            } else {
              scaleVal = Math.max(0.2, (textDrag.startW - tdx) / textDrag.startW);
            }
          }

          var newFontSize = Math.max(10, Math.round(textDrag.startFontSize * scaleVal));
          textObj.fontSize = newFontSize;
          ctx.font = newFontSize + 'px ' + customText.font;
          var newRawW = ctx.measureText(t2).width + 8;
          var newRawH = newFontSize * 1.2;
          textObj.w = textObj.vertical ? newRawH : newRawW;
          textObj.h = textObj.vertical ? newRawW : newRawH;

          // Anchor the opposite corner
          if (textDrag.mode === 'sw' || textDrag.mode === 'nw') {
            textObj.x = textDrag.startObjX + textDrag.startW - textObj.w;
          }
          if (textDrag.mode === 'ne' || textDrag.mode === 'nw') {
            textObj.y = textDrag.startObjY + textDrag.startH - textObj.h;
          }

          // Sync size slider to nearest step
          if (sizeSlider) {
            var steps = [18, 24, 32, 40, 48];
            var closest = 3;
            var minDiff = 9999;
            for (var si = 0; si < steps.length; si++) {
              var diff = Math.abs(steps[si] - textObj.fontSize);
              if (diff < minDiff) { minDiff = diff; closest = si + 1; }
            }
            sizeSlider.value = closest;
            customText.sizeStep = closest;
          }
          constrainText();
        }
        drawCanvas();

      } else if (pzDrag.active) {
        var pdx = pt.x - pzDrag.startX;
        var pdy = pt.y - pzDrag.startY;
        var minSz = 20;
        var newPZX = pzDrag.startPZX;
        var newPZY = pzDrag.startPZY;
        var newPZW = pzDrag.startPZW;
        var newPZH = pzDrag.startPZH;

        if (pzDrag.mode === 'move') {
          newPZX = pzDrag.startPZX + pdx;
          newPZY = pzDrag.startPZY + pdy;
        } else if (pzDrag.mode === 'se') {
          newPZW = Math.max(minSz, pzDrag.startPZW + pdx);
          newPZH = Math.max(minSz, pzDrag.startPZH + pdy);
        } else if (pzDrag.mode === 'sw') {
          newPZW = Math.max(minSz, pzDrag.startPZW - pdx);
          newPZH = Math.max(minSz, pzDrag.startPZH + pdy);
          newPZX = pzDrag.startPZX + pzDrag.startPZW - newPZW;
        } else if (pzDrag.mode === 'ne') {
          newPZW = Math.max(minSz, pzDrag.startPZW + pdx);
          newPZH = Math.max(minSz, pzDrag.startPZH - pdy);
          newPZY = pzDrag.startPZY + pzDrag.startPZH - newPZH;
        } else if (pzDrag.mode === 'nw') {
          newPZW = Math.max(minSz, pzDrag.startPZW - pdx);
          newPZH = Math.max(minSz, pzDrag.startPZH - pdy);
          newPZX = pzDrag.startPZX + pzDrag.startPZW - newPZW;
          newPZY = pzDrag.startPZY + pzDrag.startPZH - newPZH;
        }

        // Clamp to canvas bounds
        newPZX = Math.max(0, Math.min(CW - minSz, newPZX));
        newPZY = Math.max(0, Math.min(CH - minSz, newPZY));
        if (newPZX + newPZW > CW) newPZW = CW - newPZX;
        if (newPZY + newPZH > CH) newPZH = CH - newPZY;

        PZ.x = Math.round(newPZX);
        PZ.y = Math.round(newPZY);
        PZ.w = Math.round(newPZW);
        PZ.h = Math.round(newPZH);

        updatePZOverlay();
        drawCanvas();
      }
    }

    function onPointerUp(e) {
      var wasDragging = drag.active || textDrag.active || pzDrag.active;
      drag.active = false;
      textDrag.active = false;
      pzDrag.active = false;
      if (wasDragging) {
        var pt = canvasCoords(e);
        updateCursor(pt.x, pt.y);
        drawCanvas();
      }
    }

    canvas.addEventListener('mousedown', onPointerDown);
    canvas.addEventListener('mousemove', onPointerMove);
    canvas.addEventListener('mouseup',   onPointerUp);
    canvas.addEventListener('mouseleave', function (e) {
      if (drag.active || textDrag.active) onPointerUp(e);
    });

    canvas.addEventListener('touchstart', onPointerDown, { passive: false });
    canvas.addEventListener('touchmove',  onPointerMove, { passive: false });
    canvas.addEventListener('touchend',   onPointerUp);

    /* --------------------------------------------------------
       Custom text controls
    -------------------------------------------------------- */
    if (textInput) {
      textInput.addEventListener('input', function () {
        var wasEmpty = !customText.value.trim();
        customText.value = this.value;
        if (textCharCount) textCharCount.textContent = this.value.length + '/25';

        if (this.value.trim()) {
          if (wasEmpty) textObj.placed = false; // re-center on first character
          if (textObj.confirmed) {
            textObj.confirmed = false; // un-confirm when content changes
          }
          updateTextBounds();
          if (textConfirmArea) textConfirmArea.hidden = false;
          if (textRepositionBtn) textRepositionBtn.hidden = true;
        } else {
          textObj.placed = false;
          textObj.confirmed = false;
          if (textConfirmArea) textConfirmArea.hidden = true;
          if (textRepositionBtn) textRepositionBtn.hidden = true;
        }
        drawCanvas();
        updatePriceDisplay();
        updateSubmitState();
      });
    }

    if (fontPicker) {
      fontPicker.addEventListener('click', function (e) {
        var btn = e.target.closest('.dyo-font-btn');
        if (!btn) return;
        customText.font = btn.getAttribute('data-font');
        customText.fontLabel = btn.textContent.trim();
        var btns = fontPicker.querySelectorAll('.dyo-font-btn');
        for (var i = 0; i < btns.length; i++) {
          btns[i].classList.remove('is-active');
        }
        btn.classList.add('is-active');
        if (textObj.placed) updateTextBounds();
        drawCanvas();
      });
    }

    if (colorSwatches) {
      colorSwatches.addEventListener('click', function (e) {
        var swatch = e.target.closest('.dyo-color-swatch');
        if (!swatch) return;
        customText.color = swatch.getAttribute('data-color');
        customText.colorLabel = swatch.getAttribute('data-label') || customText.color;
        var swatchBtns = colorSwatches.querySelectorAll('.dyo-color-swatch');
        for (var i = 0; i < swatchBtns.length; i++) {
          swatchBtns[i].classList.remove('is-active');
        }
        swatch.classList.add('is-active');
        drawCanvas();
      });
    }

    if (sizeSlider) {
      sizeSlider.addEventListener('input', function () {
        customText.sizeStep = parseInt(this.value, 10);
        textObj.fontSize = SIZE_MAP[customText.sizeStep] || 32;
        if (textObj.placed) updateTextBounds();
        drawCanvas();
      });
    }

    /* --------------------------------------------------------
       Text rotate toggle
    -------------------------------------------------------- */
    function syncRotateBtn() {
      var btn = document.getElementById('dyo-text-rotate-btn');
      if (!btn) return;
      btn.setAttribute('aria-pressed', textObj.vertical ? 'true' : 'false');
      btn.classList.toggle('is-active', textObj.vertical);
      var label = document.getElementById('dyo-text-rotate-label');
      if (label) label.textContent = textObj.vertical ? 'Switch to horizontal' : 'Switch to vertical';
    }

    function toggleTextRotation() {
      textObj.vertical = !textObj.vertical;
      syncRotateBtn();
      if (textObj.placed && customText.value.trim()) {
        var cx = textObj.x + textObj.w / 2;
        var cy = textObj.y + textObj.h / 2;
        var t = customText.value.trim();
        ctx.font = textObj.fontSize + 'px ' + customText.font;
        var rawW = ctx.measureText(t).width + 8;
        var rawH = textObj.fontSize * 1.2;
        textObj.w = textObj.vertical ? rawH : rawW;
        textObj.h = textObj.vertical ? rawW : rawH;
        textObj.x = cx - textObj.w / 2;
        textObj.y = cy - textObj.h / 2;
        constrainText();
      }
      drawCanvas();
    }

    var rotateBtn = document.getElementById('dyo-text-rotate-btn');
    if (rotateBtn) {
      rotateBtn.addEventListener('click', toggleTextRotation);
    }

    /* --------------------------------------------------------
       Text confirm / reposition
    -------------------------------------------------------- */
    if (textConfirmBtn) {
      textConfirmBtn.addEventListener('click', function () {
        textObj.confirmed = true;
        if (textConfirmArea) textConfirmArea.hidden = true;
        if (textRepositionBtn) textRepositionBtn.hidden = false;
        storeTextPosition();
        uploadPreviewCanvas();
        drawCanvas();
        updateSubmitState();
      });
    }

    if (textRepositionBtn) {
      textRepositionBtn.addEventListener('click', function () {
        textObj.confirmed = false;
        textRepositionBtn.hidden = true;
        if (textConfirmArea) textConfirmArea.hidden = false;
        drawCanvas();
        updateSubmitState();
      });
    }

    function storeTextPosition() {
      if (!propCustomText) return;
      propCustomText.value = customText.value.trim();
      if (propCustomTextFont)  propCustomTextFont.value  = customText.fontLabel;
      if (propCustomTextColor) propCustomTextColor.value = customText.colorLabel || customText.color;
      if (propCustomTextSize)  propCustomTextSize.value  = SIZE_LABELS[customText.sizeStep];
    }

    /* --------------------------------------------------------
       Price display
    -------------------------------------------------------- */
    function elementCount() {
      var textConfirmed = customText.value.trim().length > 0 && textObj.confirmed;
      return (logoConfirmed ? 1 : 0) + (textConfirmed ? 1 : 0);
    }

    function elementCountPreview() {
      var textEntered = customText.value.trim().length > 0;
      var logoPresent = logo.loaded;
      return (logoPresent ? 1 : 0) + (textEntered ? 1 : 0);
    }

    function updatePriceDisplay() {
      if (!priceAmount) return;
      var count = elementCountPreview();
      var fee = selectedMethod ? selectedMethod.price * count : 0;
      var total = currentVariantPrice + fee;
      priceAmount.textContent = formatMoney(total, cfg.money_format);
    }

    /* --------------------------------------------------------
       formatMoney
    -------------------------------------------------------- */
    function formatMoney(cents, format) {
      var fmt = format || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      var amountNoDec = Math.floor(cents / 100).toString();
      var amountWithComma = formatWithComma(amount);
      var amountNoDecWithComma = formatWithComma(amountNoDec);

      return fmt
        .replace('{{amount_with_comma_separator}}', amountWithComma)
        .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecWithComma)
        .replace('{{amount_no_decimals}}', amountNoDec)
        .replace('{{amount}}', amount);
    }

    function formatWithComma(str) {
      var parts = str.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }

    /* --------------------------------------------------------
       Variant change (radio inputs outside the DYO form)
    -------------------------------------------------------- */
    document.addEventListener('change', function (e) {
      var radio = e.target;
      if (radio && radio.type === 'radio' && radio.name && radio.name.indexOf('options') !== -1) {
        // Re-read from currently selected variant
        syncVariantFromPage();
      }
    });

    // Also watch Shopify variant:change event
    document.addEventListener('variant:change', function (e) {
      var detail = e.detail;
      if (detail && detail.variant) {
        currentVariant = detail.variant;
        currentVariantPrice = currentVariant.price;
        if (variantIdInput) variantIdInput.value = currentVariant.id;
        updatePriceDisplay();
      }
    });

    function syncVariantFromPage() {
      // Try to find selected variant from page's variant picker
      var selectedId = getSelectedVariantIdFromPage();
      if (!selectedId) return;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === selectedId) {
          currentVariant = variants[i];
          currentVariantPrice = currentVariant.price;
          if (variantIdInput) variantIdInput.value = currentVariant.id;
          updatePriceDisplay();
          break;
        }
      }
    }

    function getSelectedVariantIdFromPage() {
      // Dawn uses a native <select> or a hidden input with variant id
      var sel = document.querySelector('select[name="id"]');
      if (sel) return parseInt(sel.value, 10);
      var hidden = document.querySelector('input[name="id"]');
      if (hidden) return parseInt(hidden.value, 10);
      return null;
    }

    /* --------------------------------------------------------
       Quantity controls
    -------------------------------------------------------- */
    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        qty = Math.max(1, qty - 1);
        if (qtyInput) qtyInput.value = qty;
        var display = document.getElementById('dyo-qty-display');
        if (display) display.value = qty;
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        qty = qty + 1;
        if (qtyInput) qtyInput.value = qty;
        var display = document.getElementById('dyo-qty-display');
        if (display) display.value = qty;
      });
    }

    /* --------------------------------------------------------
       File upload
    -------------------------------------------------------- */
    if (uploadBtn && fileInput) {
      uploadBtn.addEventListener('click', function () {
        fileInput.click();
      });

      fileInput.addEventListener('change', function () {
        var file = this.files && this.files[0];
        if (!file) return;

        // Validate type
        var allowedTypes = ['image/png', 'image/jpeg', 'image/svg+xml', 'image/webp'];
        if (allowedTypes.indexOf(file.type) === -1) {
          showError('Please upload a PNG, JPG, SVG, or WebP file.');
          return;
        }

        hideError();
        setUploadState('uploading');

        // Load locally for preview
        var reader = new FileReader();
        reader.onload = function (ev) {
          var img = new Image();
          img.onload = function () {
            logo.img = img;
            logo.loaded = true;

            // Center logo in print zone at a reasonable default size
            var maxW = PZ.w * 0.6;
            var maxH = PZ.h * 0.6;
            var scale = Math.min(maxW / img.naturalWidth, maxH / img.naturalHeight, 1);
            logo.w = Math.max(MIN_LOGO_PX, img.naturalWidth * scale);
            logo.h = Math.max(MIN_LOGO_PX, img.naturalHeight * scale);
            logo.x = PZ.x + (PZ.w - logo.w) / 2;
            logo.y = PZ.y + (PZ.h - logo.h) / 2;

            drawCanvas();
            showConfirmArea();

            // Upload to Cloudinary (async — preview is already shown)
            uploadToCloudinary(file);
          };
          img.onerror = function () {
            setUploadState('error');
            showError('Could not read image. Please try a different file.');
          };
          img.src = ev.target.result;
        };
        reader.onerror = function () {
          setUploadState('error');
          showError('Failed to read file. Please try again.');
        };
        reader.readAsDataURL(file);
      });
    }

    /* --------------------------------------------------------
       Cloudinary upload
    -------------------------------------------------------- */
    function uploadToCloudinary(file) {
      if (!cfg.cloudName || !cfg.uploadPreset) {
        // No Cloudinary config — just proceed without a hosted URL
        setUploadState('done');
        propLogoUrl = '';
        return;
      }

      var formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', cfg.uploadPreset);

      fetch('https://api.cloudinary.com/v1_1/' + cfg.cloudName + '/image/upload', {
        method: 'POST',
        body: formData,
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Upload failed: ' + res.status);
          return res.json();
        })
        .then(function (data) {
          propLogoUrl = data.secure_url || '';
          if (propLogoUrlInput) propLogoUrlInput.value = propLogoUrl;
          setUploadState('done');
        })
        .catch(function (err) {
          console.warn('[DYO] Cloudinary upload error:', err);
          setUploadState('error');
          showError('Logo upload failed. You can still confirm placement and we will process your design manually.');
          // Don't block the user — let them continue
          setUploadState('done');
        });
    }

    /* --------------------------------------------------------
       Preview upload (canvas blob → Cloudinary)
    -------------------------------------------------------- */
    function uploadPreviewCanvas() {
      if (!cfg.cloudName || !cfg.uploadPreset) return;

      canvas.toBlob(function (blob) {
        if (!blob) return;
        var formData = new FormData();
        formData.append('file', blob, 'dyo-preview.jpg');
        formData.append('upload_preset', cfg.uploadPreset);

        fetch('https://api.cloudinary.com/v1_1/' + cfg.cloudName + '/image/upload', {
          method: 'POST',
          body: formData,
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            propPreviewUrl = data.secure_url || '';
            if (propPreviewUrlInput) propPreviewUrlInput.value = propPreviewUrl;
          })
          .catch(function (err) {
            console.warn('[DYO] Preview upload error:', err);
          });
      }, 'image/jpeg', 0.85);
    }

    /* --------------------------------------------------------
       Upload UI states
    -------------------------------------------------------- */
    function setUploadState(state) {
      uploadState = state;
      if (!uploadIcon || !uploadLabel) return;

      uploadIcon.className = 'dyo-upload-btn__icon';

      switch (state) {
        case 'uploading':
          uploadIcon.className = 'dyo-upload-btn__icon is-spinning';
          uploadIcon.innerHTML = '';
          uploadLabel.textContent = 'Uploading…';
          break;
        case 'done':
          uploadIcon.innerHTML = svgCheck();
          uploadLabel.textContent = 'Logo Uploaded';
          break;
        case 'error':
          uploadIcon.innerHTML = svgX();
          uploadLabel.textContent = 'Upload Failed — Retry?';
          break;
        default: // idle
          uploadIcon.innerHTML = svgUpload();
          uploadLabel.textContent = 'Upload Your Logo';
          break;
      }
    }

    function svgUpload() {
      return '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>';
    }

    function svgCheck() {
      return '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#3a6a20" stroke-width="2" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
    }

    function svgX() {
      return '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#c0392b" stroke-width="2" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    }

    /* --------------------------------------------------------
       Show / hide confirm area
    -------------------------------------------------------- */
    function showConfirmArea() {
      if (confirmArea) confirmArea.hidden = false;
      if (repositionBtn) repositionBtn.hidden = true;
    }

    function hideConfirmArea() {
      if (confirmArea) confirmArea.hidden = true;
    }

    /* --------------------------------------------------------
       Confirm / reposition
    -------------------------------------------------------- */
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        logoConfirmed = true;
        hideConfirmArea();
        if (repositionBtn) repositionBtn.hidden = false;
        updateSubmitState();

        // Store logo position
        storeLogoPosition();

        // Upload preview
        uploadPreviewCanvas();

        drawCanvas();
      });
    }

    if (repositionBtn) {
      repositionBtn.addEventListener('click', function () {
        logoConfirmed = false;
        repositionBtn.hidden = true;
        showConfirmArea();
        updateSubmitState();
        drawCanvas();
      });
    }

    function storeLogoPosition() {
      if (!propLogoPositionInput) return;
      var pos = {
        x: logo.x,
        y: logo.y,
        w: logo.w,
        h: logo.h,
        canvasW: CW,
        canvasH: CH,
        xPct: logo.x / CW,
        yPct: logo.y / CH,
        wPct: logo.w / CW,
        hPct: logo.h / CH,
      };
      propLogoPositionInput.value = JSON.stringify(pos);
    }

    function enableSubmit() {
      if (!submitBtn) return;
      submitBtn.disabled = false;
      submitBtn.setAttribute('aria-disabled', 'false');
      if (submitNote) submitNote.textContent = '';
    }

    function disableSubmit(msg) {
      if (!submitBtn) return;
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-disabled', 'true');
      if (submitNote && msg) submitNote.textContent = msg;
    }

    function updateSubmitState() {
      var count = elementCount();
      var hasElement = count > 0;
      var hasMethod = selectedMethod !== null;
      var ready = hasElement && hasMethod;

      if (ready) {
        enableSubmit();
      } else if (!hasElement && !hasMethod) {
        disableSubmit('Add your logo or text, then select a decoration method');
      } else if (!hasElement) {
        disableSubmit('Upload your logo or confirm text placement to continue');
      } else {
        disableSubmit('Select a decoration method to continue');
      }
    }

    /* --------------------------------------------------------
       Error helpers
    -------------------------------------------------------- */
    function showError(msg) {
      if (!errorMsg) return;
      errorMsg.textContent = msg;
      errorMsg.hidden = false;
    }

    function hideError() {
      if (!errorMsg) return;
      errorMsg.hidden = true;
      errorMsg.textContent = '';
    }

    /* --------------------------------------------------------
       Cart submission
    -------------------------------------------------------- */
    if (dyoForm) {
      dyoForm.addEventListener('submit', function (e) {
        e.preventDefault();
        hideError();

        var count = elementCount();
        if (count === 0) {
          showError('Please upload your logo or confirm text placement before adding to cart.');
          return;
        }
        if (!selectedMethod) {
          showError('Please select a decoration method before adding to cart.');
          return;
        }

        var variantId = variantIdInput ? parseInt(variantIdInput.value, 10) : null;
        if (!variantId) {
          showError('Please select a product variant.');
          return;
        }

        var textConfirmed = customText.value.trim().length > 0 && textObj.confirmed;
        var properties = {
          'Customized':         'Yes',
          'Decoration Method':  selectedMethod.label,
          '_decoration_method': selectedMethod.key,
          '_element_count':     String(count),
        };
        if (propLogoUrl) properties['_logo_url'] = propLogoUrl;
        if (propPreviewUrl) properties['_preview_url'] = propPreviewUrl;
        if (propLogoPositionInput && propLogoPositionInput.value) {
          properties['_logo_position'] = propLogoPositionInput.value;
        }
        if (textConfirmed) {
          properties['_custom_text']       = customText.value.trim();
          properties['_custom_text_font']  = customText.fontLabel;
          properties['_custom_text_color'] = customText.color;
          properties['_custom_text_size']  = SIZE_LABELS[customText.sizeStep];
        }

        setSubmitting(true);
        uploadPreviewCanvas();
        addTowelToCart(variantId, properties, count);
      });
    }

    function addTowelToCart(variantId, properties, feeQty) {
      var body = { id: variantId, quantity: qty, properties: properties };
      cartAdd(JSON.stringify(body))
        .then(function () {
          if (feeQty > 0 && selectedMethod) {
            return addFeeToCart(feeQty);
          }
        })
        .then(function () {
          onCartSuccess();
        })
        .catch(function (err) {
          setSubmitting(false);
          var msg = err.message || 'Add to cart failed';
          if (msg.toLowerCase().indexOf('cannot find variant') !== -1) {
            var usedId = selectedMethod ? selectedMethod.variantId : 'unknown';
            msg = 'Fee variant ID "' + usedId + '" was not accepted by Shopify. Check the browser console (F12) to confirm the ID being sent. Three things to verify in Shopify Admin: (1) the ID matches the variant URL — Admin → Products → [fee product] → click variant → URL ends in /variants/XXXXXXX; (2) the fee product is Published to the Online Store channel; (3) the variant has inventory or is set to "Continue selling when out of stock".';
          }
          showError(msg);
        });
    }

    function addFeeToCart(feeQty) {
      if (!selectedMethod.variantId) return Promise.resolve(); // no variant ID configured yet
      var feeId = parseInt(selectedMethod.variantId, 10);
      console.log('[DYO] Adding fee to cart — method:', selectedMethod.key, '| variantId string:', selectedMethod.variantId, '| parsed int:', feeId, '| qty:', feeQty);
      var elements = [];
      if (logoConfirmed) elements.push('Logo');
      if (customText.value.trim() && textObj.confirmed) elements.push('Text: ' + customText.value.trim());
      var body = {
        id: feeId,
        quantity: feeQty,
        properties: {
          'Decoration': selectedMethod.label + ' \xd7 ' + feeQty + (feeQty === 1 ? ' element' : ' elements'),
          'Elements': elements.join(', '),
        },
      };
      return cartAdd(JSON.stringify(body));
    }

    function cartAdd(bodyString) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: bodyString,
      }).then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || data.message || 'Add to cart failed');
          });
        }
        return res.json();
      });
    }

    function onCartSuccess() {
      setSubmitting(false);
      // Try Shopify cart drawer refresh event
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      // Also dispatch for Dawn's cart drawer
      var event = new CustomEvent('dispatch:cart-drawer:open', { bubbles: true });
      document.documentElement.dispatchEvent(event);

      // Fallback: reload after brief delay if no cart drawer responded
      var reloaded = false;
      document.addEventListener('cart:refreshed', function handler() {
        reloaded = true;
        document.removeEventListener('cart:refreshed', handler);
      }, { once: true });

      setTimeout(function () {
        if (!reloaded) {
          window.location.href = '/cart';
        }
      }, 1200);
    }

    function setSubmitting(isSubmitting) {
      if (!submitBtn) return;
      var submitText = document.getElementById('dyo-submit-text');
      if (isSubmitting) {
        submitBtn.disabled = true;
        if (submitText) submitText.textContent = 'Adding to Cart…';
      } else {
        submitBtn.disabled = false;
        if (submitText) submitText.textContent = 'Add Customized Version to Cart';
      }
    }

    /* --------------------------------------------------------
       Print zone overlay (admin edit mode)
    -------------------------------------------------------- */
    function updatePZOverlay() {
      var xEl = document.getElementById('dyo-pz-val-x');
      var yEl = document.getElementById('dyo-pz-val-y');
      var wEl = document.getElementById('dyo-pz-val-w');
      var hEl = document.getElementById('dyo-pz-val-h');
      if (!xEl) return;
      var xPct = Math.round(PZ.x / CW * 100);
      var yPct = Math.round(PZ.y / CH * 100);
      var wPct = Math.round(PZ.w / CW * 100);
      var hPct = Math.round(PZ.h / CH * 100);
      xEl.textContent = xPct;
      yEl.textContent = yPct;
      wEl.textContent = wPct;
      hEl.textContent = hPct;
      var copyEl = document.getElementById('dyo-pz-copy-text');
      if (copyEl) {
        copyEl.textContent = 'X: ' + xPct + '  Y: ' + yPct + '  W: ' + wPct + '  H: ' + hPct;
      }
    }

    var pzCopyBtn = document.getElementById('dyo-pz-copy-btn');
    if (pzCopyBtn) {
      pzCopyBtn.addEventListener('click', function () {
        var xPct = Math.round(PZ.x / CW * 100);
        var yPct = Math.round(PZ.y / CH * 100);
        var wPct = Math.round(PZ.w / CW * 100);
        var hPct = Math.round(PZ.h / CH * 100);
        var text = xPct + ', ' + yPct + ', ' + wPct + ', ' + hPct;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(text).then(function () {
            pzCopyBtn.textContent = 'Copied!';
            setTimeout(function () { pzCopyBtn.textContent = 'Copy values'; }, 2000);
          });
        }
      });
    }

    /* --------------------------------------------------------
       Initial draw
    -------------------------------------------------------- */
    drawCanvas();
    updatePriceDisplay();
    updateSubmitState();

    // PZ edit mode — auto-open the panel and show the overlay
    if (PZ_EDIT_MODE) {
      var pzEditorEl = document.getElementById('dyo-pz-editor');
      if (pzEditorEl) pzEditorEl.hidden = false;
      if (dyoPanel) {
        dyoPanel.classList.add('is-open');
        dyoPanel.setAttribute('aria-hidden', 'false');
      }
      if (triggerBtn) {
        triggerBtn.classList.add('is-active');
        triggerBtn.setAttribute('aria-expanded', 'true');
      }
      updatePZOverlay();
    }
  }

})();
